export const NAV_HEIGHT_NUMBER = 6.5;
export const NAV_HEIGHT = `${NAV_HEIGHT_NUMBER}rem`;

export const BANNER_HEIGHT_NUMBER = 5;
export const BANNER_HEIGHT = `${BANNER_HEIGHT_NUMBER}rem`;
